import { hideLoader } from "./loader";
import { exitRedirect } from "./exit";

export const showPhase = (phaseName) => {
    if (window['extendShowPhase'] && typeof extendShowPhase === 'function') {
        extendShowPhase(phaseName);
    }

    const nextPhase = document.querySelector(`#phase${phaseName}`);

    document
        .querySelectorAll('[id^=phase]')
        .forEach(x => x.style.display = 'none');

    nextPhase.style.display = 'block';
    hideLoader();

    if (phaseName === 'Success') {
        exitRedirect('payment_success');
    }

    if (phaseName === 'Error') {
        exitRedirect('payment_failure');
    }
}

window.showPhase = showPhase;
